var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = 168
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16